{
  "unitLevelOrderHistory": {
    "orderHistory": "Unit-level order history",
    "orderId": "Order #",
    "emptyPurchaseOrderId": "None",
    "date": "Fecha",
    "status": "Status",
    "buyer": "Buyer",
    "unit": "Unit",
    "total": "Total",
    "noOrders": "We have no matching order records for your unit.",
    "startShopping": "Start Shopping",
    "sortBy": "Sort by",
    "sortOrders": "Sort orders",
    "purchaseOrderNumber": "PO #",
    "startOn": "Start On",
    "frequency": "Frequency",
    "nextOrderDate": "Next Order Date",
    "notFound": "No Orders Found",
    "applyFilter": "Apply",
    "filterBy": "Filter by",
    "filterByBuyer": "Filter by Buyer",
    "filterByBuyerLabel": "Buyer name",
    "filterByBuyerPlaceholder": "Enter buyer name",
    "filterByBuyerAriaLabel": "Filter list by buyer",
    "filterByUnit": "Filter by Unit",
    "filterByUnitLabel": "Unit name",
    "filterByUnitPlaceholder": "Enter unit name",
    "filterByUnitAriaLabel": "Filter list by unit",
    "search": "Search",
    "clearAll": "Clear All",
    "removeAppliedFilters": "Remove filters",
    "yourFilters": "Your Filters:",
    "and": " and "
  },
  "unitLevelOrderHistorySorting": {
      "date": "Fecha",
      "orderNumber": "Número de pedido",
      "buyer": "Comprador (Ascendente)",
      "buyerDesc": "Comprador (Descendente)",
      "orgUnit": "Unidad (Ascendente)",
      "orgUnitDesc": "Unidad (Descendente)"
    },
    "unitLevelOrderDetails": {
      "buyer": "Comprador"
    }
}
